/**
Project: Phone Connect (c)
Title: Constants
Description: Constants used for Redux store
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
export const APP_NAME = "APP_NAME";
export const IDENTITY_PROFILE = "IDENTITY_PROFILE";
export const LOGIN_TYPE = "LOGIN_TYPE";
export const USER_CONSENT_DATA = "USER_CONSENT_DATA";